import * as ProfileLevelColors from '../constants/ProfileLevelColor';
import * as PartnerTiers from '../constants/PartnerTier';
import * as PartnerTypes from '../constants/PartnerType';
export const getProfileLevelColorUse = (partnerType, tier) => {
  if (tier === PartnerTiers.NONE) {
    if (partnerType === PartnerTypes.PARTNER || partnerType === PartnerTypes.RESELLER) {
      return ProfileLevelColors.PARTNER_SOLUTIONS;
    } else if (partnerType === PartnerTypes.PROVIDER) {
      return ProfileLevelColors.PROVIDER;
    } else {
      return undefined;
    }
  } else {
    return ProfileLevelColors[`PARTNER_${tier}`];
  }
};